// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1kX79","wrap":"App_wrap__29kNz","footer":"App_footer__29Fsv"};